module.exports = __webpack_public_path__ + "971e717980dbfb4b91b802d823c22f1d.jpg";